import type { ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { sbEditable } from '@storyblok/storyblok-editable';
import styles from './MediaLayout.module.scss';
import Text from '../../atoms/text/Text';
import type { VideoBlockBlokData } from '../../blocks/video-block/VideoBlock.data';
import type { ImageBlockBlokData } from '../../blocks/image-block/ImageBlock.data';

interface MediaLayoutProps {
  className: string;
  blok: VideoBlockBlokData | ImageBlockBlokData;
  children: ReactNode;
  ref?: Ref<HTMLDivElement | null>;
}

export type LayoutSizes = 'small' | 'large' | 'full-width';

export const MediaLayout = ({ ref, ...props }: MediaLayoutProps) => (
  <figure
    ref={ref}
    className={classNames(styles.parentFigure, props.className, {
      [styles.smallInline]: props.blok.layout_size === 'small',
      [styles.largeInline]: props.blok.layout_size === 'large',
      [styles.fullWidth]: props.blok.layout_size === 'full-width',
      [styles.noMargins]: props.blok.no_margins,
    })}
    {...sbEditable(props.blok)}
  >
    {props.children}
    {props.blok.caption && (
      <Text as="figcaption" size="body-standard" disableTriggerInOnScroll={false}>
        {props.blok.caption}
      </Text>
    )}
  </figure>
);
